import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { MapPinOff, Check } from 'lucide-react';
import { getAuthHeader } from '../../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/carte-vivante`;

function Ligne({ d, territoires, onPlace }) {
  const [t, setT] = useState('');
  const enregistrer = async () => {
    try {
      await axios.put(`${API}/dommages/${d.id}/territoire`, { territoire: t }, { headers: getAuthHeader() });
      toast.success(`Dommage placé en ${t}`);
      onPlace(d.id);
    } catch (e) { toast.error(e.response?.data?.detail || 'Enregistrement impossible'); }
  };
  return (
    <tr className="border-b border-white/5 align-top" data-testid={`dommage-sans-territoire-${d.id}`}>
      <td className="py-2 pr-3">{d.date_sinistre ? String(d.date_sinistre).slice(0, 10).split('-').reverse().join('/') : '—'}</td>
      <td className="py-2 pr-3">{d.description || '—'}<div className="text-[11px] text-slate-500">{d.raison_sociale || (d.contrat_trouve ? 'Contrat sans territoire' : 'Contrat introuvable')}{d.numero_police ? ` · ${d.numero_police}` : ''}</div></td>
      <td className="py-2 pr-3"><span className={d.etat === 'termine' ? 'text-indigo-300' : 'text-red-300'}>{d.etat === 'termine' ? 'Terminé' : 'En cours'}</span></td>
      <td className="py-2">
        <div className="flex gap-2">
          <select value={t} onChange={(e) => setT(e.target.value)} className="rounded-lg border border-white/10 bg-slate-900 px-2 py-1 text-xs" data-testid={`dommage-territoire-select-${d.id}`}>
            <option value="">Choisir…</option>
            {territoires.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
          <button type="button" disabled={!t} onClick={enregistrer} className="inline-flex items-center gap-1 rounded-full bg-emerald-500 px-3 py-1 text-xs font-semibold text-slate-950 disabled:opacity-40" data-testid={`dommage-territoire-enregistrer-${d.id}`}><Check className="h-3.5 w-3.5" />Placer</button>
        </div>
      </td>
    </tr>
  );
}

export default function DommagesSansTerritoire({ onChange }) {
  const [data, setData] = useState(null);
  const [ouvert, setOuvert] = useState(false);
  useEffect(() => {
    axios.get(`${API}/dommages-sans-territoire`, { headers: getAuthHeader() }).then((r) => setData(r.data)).catch(() => setData({ dommages: [], territoires: [] }));
  }, []);
  if (!data || data.dommages.length === 0) return null;
  const place = (id) => { setData((x) => ({ ...x, dommages: x.dommages.filter((d) => d.id !== id) })); onChange?.(); };
  return (
    <div className="rounded-2xl border border-amber-400/30 bg-amber-500/5 p-4 text-sm text-slate-200" data-testid="dommages-sans-territoire">
      <button type="button" onClick={() => setOuvert(!ouvert)} className="flex w-full items-center justify-between text-left font-semibold text-amber-200" data-testid="dommages-sans-territoire-toggle">
        <span className="flex items-center gap-2"><MapPinOff className="h-4 w-4" />{data.dommages.length} dommage(s) sans territoire — à compléter pour les placer sur la carte</span>
        <span className="text-xs">{ouvert ? 'Masquer' : 'Afficher'}</span>
      </button>
      {ouvert && (
        <div className="mt-3 max-h-96 overflow-auto">
          <table className="w-full text-xs">
            <thead className="text-left text-slate-400"><tr><th className="py-1">Date</th><th>Dommage / contrat</th><th>État</th><th>Territoire</th></tr></thead>
            <tbody>{data.dommages.map((d) => <Ligne key={d.id} d={d} territoires={data.territoires} onPlace={place} />)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
